import { Component, OnInit } from '@angular/core';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { CartEditorInputComponent } from './cart-editor-input/cart-editor-input.component';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { EditorService } from '../services/editor.service';
import { BaseEditor } from '../base-editor';

@Component({
  selector: 'kve-cart-editor',
  templateUrl: './cart-editor.component.html',
  styleUrls: ['./cart-editor.component.scss']
})
export class CartEditorComponent extends BaseEditor implements OnInit {
  inputComponent = new DynamicInputComponent(CartEditorInputComponent);

  title = "Editing Cart Route";
  menuTag = "editCartRouteMenu";
  menuGroup:MenuGroup = {
    title:"Editing Cart Route",
    menuTag:"editCartRouteMenu",
    menuItems: [
      {
        title:"Page Settings"
      },
      {
        title:"Sections"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ]
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  previousMenu:NbMenuItem[] = [];
  menuItems:NbMenuItem[] = [
    {
      title:'Settings'
    },
    {
      title:'Payment Methods'
    },
    {
      title:'Shipping',
    }
  ]
  
  constructor(editorService:EditorService,
    menuService:NbMenuService) { 
      super(editorService,menuService)
    }

  ngOnInit(): void {
    super.ngOnInit()
  }

}
